import { gql } from "@apollo/client";

export const PROMOTION_FRAGMENT = gql`
  fragment PromotionFields on Promotion {
    id
    title
    description
    image
    active
    createdAt
    updatedAt
    products
    endDate
    order
  }
`;

export const GET_PROMOTION = gql`
  ${PROMOTION_FRAGMENT}
  query GetPromotion($where: PromotionWhereInput!) {
    promotion(where: $where) {
      ...PromotionFields
    }
  }
`;

export const GET_PROMOTIONS = gql`
  ${PROMOTION_FRAGMENT}
  query GetPromotions($skip: Int, $take: Int, $where: PromotionsWhereInput) {
    promotions(skip: $skip, take: $take, where: $where) {
      ...PromotionFields
    }
    promotionsCount
  }
`;

export const CREATE_PROMOTION = gql`
  ${PROMOTION_FRAGMENT}
  mutation CreatePromotion($data: CreatePromotionInput!) {
    createPromotion(data: $data) {
      ...PromotionFields
    }
  }
`;

export const UPDATE_PROMOTION = gql`
  ${PROMOTION_FRAGMENT}
  mutation UpdatePromotion(
    $where: PromotionWhereInput!
    $data: UpdatePromotionInput!
  ) {
    updatePromotion(where: $where, data: $data) {
      ...PromotionFields
    }
  }
`;

export const DELETE_PROMOTION = gql`
  mutation DeletePromotion($where: PromotionWhereInput!) {
    deletePromotion(where: $where) {
      id
    }
  }
`;

export const UPDATE_PROMOTIONS_ORDER = gql`
  mutation UpdatePromotionsOrder($ids: [String!]!) {
    updatePromotionsOrder(ids: $ids)
  }
`;
